import React from "react";
import { useNavigate } from "react-router";

function HomeScreenViewAllAppsView() {
  //react router navigate
  const navigate = useNavigate(); //react router navigate

  return (
    <div className="container text-center" style={{ marginTop: "5rem" }}>
      {/* Button browse all pdf tools */}
      <div className="mt-5">
        <button
          type="button"
          className="btn btn-primary px-5 py-3 fs-5 rounded-5"
          onClick={(e) => {
            navigate("/explore_apps"); //Navigate to new route
          }}
        >
          View All Tools
        </button>
      </div>
    </div>
  );
}

export default HomeScreenViewAllAppsView;
